var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-upload",
        _vm._b(
          {
            ref: "upload",
            class: { disabled: _vm.uploadDisabled || _vm.isLimitBeyond },
            staticStyle: { width: "100%" },
            attrs: {
              name: "file",
              action: _vm.filePath,
              headers: _vm.header,
              "list-type": _vm.listType,
              "file-list": _vm.fileList,
              "show-file-list": true,
              "on-error": _vm.handleUploadError,
              "before-upload": _vm.handleBeforeUpload,
              "on-success": _vm.uploadSuccess,
              "on-progress": _vm.onProgress,
              "on-exceed": _vm.handleExceed,
              data: { code: _vm.code },
              limit: _vm.limit,
              accept: _vm._accept,
              disabled: _vm.disabled,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "file",
                  fn: function (ref) {
                    var file = ref.file
                    return _vm._t(
                      "file",
                      function () {
                        return [
                          _c(
                            "div",
                            [
                              _vm.isImage(file)
                                ? _c("el-image", {
                                    ref: "previewImg",
                                    staticStyle: {
                                      "border-radius": "6px",
                                      width: "148px",
                                      height: "148px",
                                    },
                                    attrs: {
                                      src: file.url,
                                      "preview-src-list": [_vm.clickFileUrl],
                                    },
                                  })
                                : _c(
                                    "div",
                                    { staticClass: "box font-12 color-999" },
                                    [
                                      _c("i", {
                                        staticClass: "el-icon-document font-24",
                                      }),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.isPdf ? "PDF" : "") +
                                            "文件已上传"
                                        ),
                                      ]),
                                      _c("span", [_vm._v("可下载预览")]),
                                    ]
                                  ),
                              _c(
                                "span",
                                { staticClass: "el-upload-list__item-actions" },
                                [
                                  _vm.isImage(file)
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "el-upload-list__item-preview",
                                          on: {
                                            click: function ($event) {
                                              return _vm.handlePictureCardPreview(
                                                file
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-zoom-in",
                                          }),
                                        ]
                                      )
                                    : _vm._e(),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "el-upload-list__item-delete",
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleDownload(file)
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "el-icon-download",
                                      }),
                                    ]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "el-upload-list__item-delete",
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleRemove(file)
                                        },
                                      },
                                    },
                                    [_c("i", { staticClass: "el-icon-delete" })]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                      null,
                      { file: file }
                    )
                  },
                },
              ],
              null,
              true
            ),
          },
          "el-upload",
          _vm.$attrs,
          false
        ),
        [
          _vm._t("default", function () {
            return [_c("i", { staticClass: "el-icon-plus" })]
          }),
          _vm._t(
            "tip",
            function () {
              return [
                _c(
                  "div",
                  {
                    staticClass: "el-upload__tip",
                    staticStyle: { width: "148px", "text-align": "center" },
                  },
                  [
                    _vm._v(
                      "\n        " + _vm._s(_vm.instructionText) + "\n      "
                    ),
                  ]
                ),
              ]
            },
            { slot: "tip" }
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }